import React, { Component } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import SVG from 'react-inlinesvg';
import searchIcon from '@lifesize/ux-assets/vectors/svgIcons/search.svg';
import { FAVORITES_FORM } from 'constants/Favorites';
import classes from './FavoritesSearch.module.scss';

const MAX_FAVORITES = 99;

const messages = defineMessages({
  searchNonFavorites: {
    id: 'components.home.favorites.favoritesSearch',
    defaultMessage: 'Search to add'
  },
  maxFavorites: {
    id: 'components.home.favorites.maxFavorites',
    defaultMessage: 'Maximum favorites reached!'
  }
});

class FavoritesSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholder: this.getPlaceholderText()
    };
    this.focus = this.focusHandler.bind(this);
  }

  componentDidMount() {
    // give the field focus
    this.searchField.getRenderedComponent().focus();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.props.handleSetIsFocused(nextProps.isFocused);
    setTimeout(() => {
      this.setState({
        placeholder: this.getPlaceholderText()
      });
    }, 0);
  }

  componentDidUpdate() {
    if (this.props.blurred) {
      this.searchField.getRenderedComponent().blur();
      this.props.blurInput();
      setTimeout(() => {
        this.setState({
          placeholder: this.getPlaceholderText()
        });
      }, 0);
    }
  }

  getPlaceholderText() {
    if (this.props.numFavorites >= MAX_FAVORITES) {
      return this.props.intl.formatMessage(messages.maxFavorites);
    }
    return this.props.intl.formatMessage(messages.searchNonFavorites);
  }

  focusHandler() {
    this.props.handleSetIsFocused(true);
    this.setState({
      placeholder: ''
    });
  }

  render() {
    return (
      <div className={classes.favoritesSearchBarWrapper}>
        <Field
          onFocus={this.focus}
          name="favoritesSearchBar"
          component="input"
          type="text"
          className={classes.favoritesSearchBar}
          placeholder={this.state.placeholder}
          ref={(input) => { this.searchField = input; }}
          forwardRef
          disabled={this.props.numFavorites >= MAX_FAVORITES}
          maxLength={64}
        />
        <SVG src={searchIcon} className={classes.searchIcon} />
      </div>
    );
  }
}

FavoritesSearchBar.propTypes = {
  intl: PT.object,
  numFavorites: PT.number,
  handleSetIsFocused: PT.func,
  blurred: PT.bool,
  blurInput: PT.func,
  isFocused: PT.bool
};

export default reduxForm({
  form: FAVORITES_FORM,
  getFormState: state => state.app.form
})(injectIntl(FavoritesSearchBar));

